<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span [ngClass]="classAttribute"></span>
        {{ title | translate }}</mat-panel-title
      >
      <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutAlign.gt-xs="end center"
        fxLayoutGap="16px"
        *ngIf="!isSpecificSearch && hasAnyOperation()"
      >
        <button
          id="allRequestsRequestPanel"
          mat-flat-button
          color="accent"
          (click)="onClickViewAllRequests($event)"
          *ngIf="isMainPanel"
        >
          <span>{{ 'request.button.allRequestsMini' | translate | uppercase }}</span>
        </button>
        <div *ngIf="!isMainPanel" fxLayout="row" fxLayoutAlign="start end" class="buttonsExport">
          <button id="createExcelPanel" mat-stroked-button color="accent" (click)="createExcel($event)">
            <mat-icon class="icon-ic_file_download"></mat-icon>
            <span>{{ 'request.button.excel' | translate | uppercase }}</span>
          </button>
        </div>
      </div>
      <!-- HEADER -->
    </mat-expansion-panel-header>

    <mat-divider *ngIf="!hasAnyOperation()"></mat-divider>

    <!-- CONTENT -->
    <mat-card-content [ngClass]="!hasAnyOperation() ? 'panel-request__card-content--divider' : ''" fxLayout="row wrap">
      <div class="table__wrapper">
        <!-- TABLE -->
        <table mat-table [dataSource]="dataSource" *ngIf="hasAnyOperation(); else showNoOperations">
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef translate class="mat-header-cell--chip">request.status</th>
            <td mat-cell *matCellDef="let element" class="mat-cell--center first-col">
              <mat-chip-list *ngIf="element.hostStatus && checkNameColorStatus(element).class !== 'no-status'">
                <ng-container *ngIf="checkNameColorStatus(element) as status">
                  <mat-chip [ngClass]="status.class" (click)="handleChipClick(status, element)">
                    {{ status.name }}
                  </mat-chip>
                </ng-container>
              </mat-chip-list>
            </td>
          </ng-container>
          <ng-container matColumnDef="numberRequest">
            <th mat-header-cell *matHeaderCellDef translate>request.numberRequest</th>
            <td mat-cell *matCellDef="let element">{{ element.numOperation }}</td>
          </ng-container>
          <ng-container matColumnDef="canal">
            <th mat-header-cell *matHeaderCellDef translate>request.captacionCanal</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IT; else WS">IC</span>
              <ng-template #WS>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.WS; else GlobalCredit">WebService</span>
              </ng-template>
              <ng-template #GlobalCredit>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.GLOBAL_CREDIT; else OptimCredit"
                  >GlobalCredit</span
                >
              </ng-template>
              <ng-template #OptimCredit>
                <span
                  *ngIf="
                    element.captacionCanal === CAPTACION_CANAL.OPTIM_CREDIT_OF ||
                      element.captacionCanal === CAPTACION_CANAL.OPTIM_CREDIT_OC;
                    else App
                  "
                  >OptimCredit</span
                >
              </ng-template>
              <ng-template #App>
                <span
                  *ngIf="
                    element.captacionCanal === CAPTACION_CANAL.APP_AE ||
                      element.captacionCanal === CAPTACION_CANAL.APP_AP;
                    else mango
                  "
                  >App</span
                >
              </ng-template>
              <ng-template #mango>
                <span
                  *ngIf="
                    element.captacionCanal === CAPTACION_CANAL.MANGO_FO ||
                      element.captacionCanal === CAPTACION_CANAL.MANGO_OL;
                    else telefono
                  "
                  >Mango</span
                >
              </ng-template>
              <ng-template #telefono>
                <span
                  *ngIf="
                    element.captacionCanal === CAPTACION_CANAL.TELEFONO_FX ||
                      element.captacionCanal === CAPTACION_CANAL.TELEFONO_TE ||
                      element.captacionCanal === CAPTACION_CANAL.TELEFONO_ON;
                    else icec
                  "
                  >Teléfono</span
                >
              </ng-template>
              <ng-template #icec>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IC_EC; else icstore">IC EC</span>
              </ng-template>
              <ng-template #icstore>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IC_STORE; else bpmng">IC Store</span>
              </ng-template>
              <ng-template #bpmng>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.BP_MNG; else bpquiosco">BP/MNG EC</span>
              </ng-template>
              <ng-template #bpquiosco>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.BP_QUIOSCO; else ictpv">BP Quiosco</span>
              </ng-template>
              <ng-template #ictpv>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IC_TPV; else prescriptores">IC TPV</span>
              </ng-template>
              <ng-template #prescriptores>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.PRESCRIPTORES; else icws">Prescriptores</span>
              </ng-template>
              <ng-template #icws>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IC_WS; else icgc">IC WS</span>
              </ng-template>
              <ng-template #icgc>
                <span *ngIf="element.captacionCanal === CAPTACION_CANAL.IC_GC; else otro">IC GC</span>
              </ng-template>
              <ng-template #otro> </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="firstUpdate">
            <th mat-header-cell *matHeaderCellDef translate>request.firstUpdate</th>
            <td mat-cell *matCellDef="let element">{{ element.dateEntry }}</td>
          </ng-container>
          <ng-container matColumnDef="lastUpdate">
            <th mat-header-cell *matHeaderCellDef translate>request.lastUpdate</th>
            <td mat-cell *matCellDef="let element">{{ element.dateStatus }}</td>
          </ng-container>
          <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef translate>request.nameClient</th>
            <td mat-cell *matCellDef="let element">{{ element.nameHolder }}</td>
          </ng-container>
          <ng-container matColumnDef="seller">
            <th mat-header-cell *matHeaderCellDef translate>request.seller</th>
            <td mat-cell *matCellDef="let element">{{ element.nameVendor }}</td>
          </ng-container>
          <ng-container matColumnDef="financed">
            <th mat-header-cell *matHeaderCellDef translate>request.financed</th>
            <td mat-cell *matCellDef="let element">{{ element.financed | transformEuroCurrency }}</td>
          </ng-container>
          <ng-container matColumnDef="signature">
            <th mat-header-cell *matHeaderCellDef translate>request.signature</th>
            <td mat-cell *matCellDef="let element">
              <mat-chip-list *ngIf="isEnabledINE(element); else videoselfing">
                <mat-chip class="pointer" color="primary" (click)="onClickPendingINE(element)" translate
                  >chips.INE</mat-chip
                >
              </mat-chip-list>
              <ng-template #videoselfing>
                <mat-chip-list *ngIf="isEnabledVideoselfing(element); else signature">
                  <mat-chip class="pointer" color="primary" (click)="onClickVideoselfing(element)" translate
                    >chips.videoselfing</mat-chip
                  >
                </mat-chip-list>
              </ng-template>
              <ng-template #signature>
                <mat-chip-list *ngIf="isEnabledDigitalSignature(element); else signatureForwarding">
                  <mat-chip
                    class="pointer"
                    color="primary"
                    (click)="
                      isEnabledDigitalSignature(element) ? onClickSign(element) : onClickForwardAcquiescence(element)
                    "
                    translate
                    >chips.signatureSync</mat-chip
                  >
                </mat-chip-list>
              </ng-template>
              <ng-template #signatureForwarding>
                <mat-chip-list *ngIf="isEnabledForwarding(element); else showEmpty">
                  <mat-chip
                    class="pointer"
                    color="primary"
                    (click)="
                      isEnabledDigitalSignature(element) ? onClickSign(element) : onClickForwardAcquiescence(element)
                    "
                    translate
                    >chips.signatureAsync</mat-chip
                  >
                </mat-chip-list>
              </ng-template>
              <ng-template #showEmpty>
                <mat-label></mat-label>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell--actions"></th>
            <td mat-cell *matCellDef="let element" class="mat-cell--buttons">
              <button
                id="viewRequestButtonPanel"
                mat-stroked-button
                class="mat-cell__buttons"
                (click)="onClickViewRequest(element)"
                *ngIf="isEnabledviewRequest(element)"
                [disabled]="!hasViewAttribution() && element.finacialProduct !== '15'"
              >
                <mat-icon
                  [ngClass]="
                    element.editable || (element.status === '00' && element.operative !== 'EIC')
                      ? 'icon-ic_create'
                      : 'icon-ic_visibility'
                  "
                ></mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="more">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell--actions" translate>request.more</th>
            <td mat-cell *matCellDef="let element; let i = index" class="mat-cell--buttons">
              <button
                id="dropRequestMenuPanel"
                mat-icon-button
                [matMenuTriggerFor]="menu"
                class="mat-cell__buttons"
                aria-label="More actions"
                (onMenuOpen)="onMenuOpen(i)"
                (onMenuClose)="onMenuClose()"
                [disabled]="
                  !(hasAttachAttribution(element) && !isOperativeEIC(element)) &&
                  !(isEnabledINE(element) && !isOperativeEIC(element)) &&
                  !(
                    isEnabledDigitalSignature(element) &&
                    (!isEnabledINE(element) || element.noMobile) &&
                    !isOperativeEIC(element)
                  ) &&
                  !isEnabledForwarding(element) &&
                  !(hasPrintingOrSigningAttribution() && isEnabledPrinting(element)) &&
                  !isEnabledPaymentSheets(element) &&
                  !isEnabledForwardLink(element)
                "
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  id="attachOptionRequestPanel"
                  mat-menu-item
                  *ngIf="hasAttachAttribution(element) && !isOperativeEIC(element)"
                  (click)="onClickAttach(element)"
                >
                  <mat-icon class="icon-ic_clip-bold"></mat-icon>
                  <span translate>request.button.attach</span>
                </button>
                <button
                  id="pendingINEOptionRequestPanel"
                  mat-menu-item
                  (click)="onClickPendingINE(element)"
                  *ngIf="isEnabledINE(element) && !isOperativeEIC(element)"
                >
                  <mat-icon class="icon-ic_ine"></mat-icon>
                  <span translate>request.button.pendingINE</span>
                </button>
                <button
                  id="videoselfingOptionRequestPanel"
                  mat-menu-item
                  (click)="onClickVideoselfing(element)"
                  *ngIf="isEnabledVideoselfing(element) && !isEnabledINE(element)"
                >
                  <mat-icon>camera_alt</mat-icon>
                  <span translate> resquest.pending.videoselfing</span>
                </button>
                <button
                  id="signatureOptionRequestPanel"
                  mat-menu-item
                  *ngIf="
                    isEnabledDigitalSignature(element) &&
                    (!isEnabledVideoselfing(element) || element.noMobile) &&
                    (!isEnabledINE(element) || element.noMobile) &&
                    !isOperativeEIC(element)
                  "
                  (click)="onClickSign(element)"
                >
                  <mat-icon class="icon-ic_sign"></mat-icon>
                  <span translate>request.button.sign</span>
                </button>
                <button
                  id="forwardingOptionRequestPanel"
                  mat-menu-item
                  *ngIf="isEnabledForwarding(element)"
                  (click)="onClickForwardAcquiescence(element)"
                >
                  <mat-icon class="icon-ic_inbox_message"></mat-icon>
                  <span translate>request.button.forwardAcquiescence</span>
                </button>
                <button
                  id="printOptionRequestPanel"
                  mat-menu-item
                  *ngIf="
                    hasPrintingOrSigningAttribution() && isEnabledPrinting(element) && hasPrintingVideoSelfing(element)
                  "
                  (click)="onClickPrint(element)"
                >
                  <mat-icon class="icon-ic_printer"></mat-icon>
                  <span translate>request.button.print</span>
                </button>
                <button
                  id="paymentsheetOptionRequestPanel"
                  mat-menu-item
                  *ngIf="isEnabledPaymentSheets(element)"
                  (click)="onClickPaymentSheet(element)"
                >
                  <mat-icon class="icon-ic_payment-sheet"></mat-icon>
                  <span translate>request.button.paymentSheet</span>
                </button>
                <button
                  id="forwardLinkOptionRequestPanel"
                  mat-menu-item
                  *ngIf="isEnabledForwardLink(element)"
                  (click)="onClickForwardLink(element)"
                >
                  <mat-icon class="icon-ic_inbox_message"></mat-icon>
                  <span translate>Reenviar link</span>
                </button>
                <!-- <button
                id="cancelOptionRequestPanel"
                mat-menu-item
                *ngIf="isEnabledCancel(element)"
                (click)=""
              >
                <mat-icon class="icon-ic_circle_cross"></mat-icon>
                <span translate>Anular Solicitud</span>
              </button> -->
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            [class]="i === selectedRow ? 'selected-row' : undefined"
            *matRowDef="let row; let i = index; columns: displayedColumns"
          ></tr>
        </table>
      </div>

      <ng-template #showNoOperations>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-label class="panel-request__label-no-operation" translate>request.noOperations</mat-label>
        </div>
      </ng-template>
    </mat-card-content>
    <!-- BUTTONS -->
    <div fxLayout="row" class="panel-request__card-footer" *ngIf="hasAnyOperation()">
      <div fxLayout="row">
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickPreviousPage()"
          [disabled]="!hasPreviousKey"
        >
          <mat-icon [class]="hasPreviousKey ? 'icon-ic_chevron_left' : 'icon-ic_chevron_left disabled'"></mat-icon>
        </button>
        <button
          id="nextPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickNextPage()"
          [disabled]="!hasNextKey"
        >
          <mat-icon [class]="hasNextKey ? 'icon-ic_chevron_right' : 'icon-ic_chevron_right disabled'"></mat-icon>
        </button>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<p></p>
